import React from 'react';
import { Button } from '@lt/components';

import { useTranslation } from '@lt/localization';
import SimilarPackageHotelButton from './SimilarPackageHotelButton';
import { getTextForSimilarFail } from './utils';
import type { SimilarPackagesFailProps } from './types';

const SimilarPackagesFail = ({
  baseCls,
  hasAdjustParams,
  onClose,
  isHotelOnly,
}: SimilarPackagesFailProps) => {
  const { title, description } = getTextForSimilarFail(
    isHotelOnly,
    hasAdjustParams,
  );
  const { t } = useTranslation();

  return (
    <>
      <div className={`${baseCls}__title`}>{title}</div>
      <div className={`${baseCls}__message`}>{description}</div>

      {hasAdjustParams ? (
        <Button
          primary
          onClick={onClose}
          className="similar-packages__hotel-button lt-button-link"
        >
          {t('checkout.similarPackage.backButton')}
        </Button>
      ) : (
        <SimilarPackageHotelButton />
      )}
    </>
  );
};

export default SimilarPackagesFail;
